module.exports = "/images/im-logo.gif?99c7bf0a569f8f107ad7862201454067";